import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router/router';
import store from '@/store/store';
import auth from '@/auth/auth0';
import firebase from '@/auth/firebase';
import '@/filters';

// Style
import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@/assets/css/style.scss';

Vue.use(auth);
Vue.use(firebase);

// <template>内で環境変数を呼び出せるようにする
Vue.prototype.$constants = {
  appUrl: {
    company: process.env.VUE_APP_COMPANY_APP_URL + '/dashboard',
    influencer: process.env.VUE_APP_INFLUENCER_APP_URL + '/projects'
  },
  chatUrl: process.env.VUE_APP_CHAT_URL,
  siteName: process.env.VUE_APP_SITE_NAME,
  siteUrl: {
    company: process.env.VUE_APP_COMPANY_SITE_URL,
    influencer: process.env.VUE_APP_INFLUENCER_SITE_URL
  },
  profileUrl: {
    company: process.env.VUE_APP_SITE_URL + '/account',
    influencer: process.env.VUE_APP_INFLUENCER_SITE_URL + '/account'
  },
  faqUrl: {
    company: process.env.VUE_APP_COMPANY_ZENDESK_URL,
    influencer: process.env.VUE_APP_INFLUENCER_ZENDESK_URL
  },
  inquiryUrl: {
    company: process.env.VUE_APP_COMPANY_ZENDESK_URL + '/requests/new',
    influencer: process.env.VUE_APP_INFLUENCER_ZENDESK_URL + '/requests/new'
  },
  termsUrl: {
    company: process.env.VUE_APP_COMPANY_APP_URL + '/corporate/terms',
    influencer: process.env.VUE_APP_INFLUENCER_APP_URL + '/terms/service'
  },
  privacypolicyUrl: {
    company: process.env.VUE_APP_COMPANY_APP_URL + '/corporate/privacy',
    influencer: process.env.VUE_APP_CORPORATE_URL + 'privacy_policy/'
  },
  corporateUrl: process.env.VUE_APP_CORPORATE_URL
};

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
